<template>
            <v-dialog v-model="visFl" scrollable @keydown.enter="doAct" max-width="380">
               <v-card>
                <v-card-title class="headline">
                  {{ $t( 'message.set_2fa_title', { val: userN } ) }}
                </v-card-title>
                <v-card-text>
                    
                        <p>{{ $t( 'message.use_2fa_msg1' ) }}</p>
                        <p>{{ $t( 'message.use_2fa_msg2' ) }}
                     <b>{{ $t( 'message.use_2fa_msg3' ) }}</b>
                        {{ $t( 'message.use_2fa_msg4' ) }}</p>
                        <p>{{ $t( 'message.use_2fa_msg5' ) }}</p>
                        <p>{{ $t( 'message.use_2fa_msg6', { val: code2fa } ) }}</p>
                        <img :src="qrSrc" v-show="code2fa" style="margin-bottom: -50px"></img>

                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click.native="doAct()">{{ $t( 'message.ok_btn' ) }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>   
</template>

<script>
    
import Vue from 'vue'
import{ conf } from '@/utils/confTruePLM';

export default {
  name: 'confirm2fa',
  data () 
  {
    return {
        visFl: false,
        
        use2fa: false,
        code2fa: null,
        showCode: false,
        qrSrc: '',
        userN: '',

        resolve: null,
        reject: null,
        valid: true
    };
  },
  computed: {
     
  },
  methods: {
      open( code2fa, user )
      {
          this.userN = user;
          this.code2fa = code2fa;
          this.qrSrc = conf.getQRcodeLink( user );
          
          this.visFl = true;
          
          return new Promise( ( resolve, reject ) => 
          {
            this.resolve = resolve;
            this.reject = reject;
          });
      },
      doAct()
      {
         this.visFl = false;
         this.resolve();
      }
    }
}
</script>



